"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitIconButton = exports.PreviousIconButton = exports.NextIconButton = exports.LinkIconButton = exports.CloseIconButton = exports.ContinueIconButton = exports.DownloadIconButton = exports.ExportIconButton = exports.CreateIconButton = exports.DeleteIconButton = exports.UpdateIconButton = exports.IconButton = exports.IconButtonDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("./icon");
var router_1 = require("@reach/router");
var icons_1 = require("../icons");
var utils_1 = require("@shapeable/utils");
var cls = (0, utils_1.classNames)('icon-button');
var PencilCircle = icons_1.Icons.PencilCircle,
  CrossCircle = icons_1.Icons.CrossCircle,
  PlusCircle = icons_1.Icons.PlusCircle,
  MinusCircle = icons_1.Icons.MinusCircle,
  ChevronRight = icons_1.Icons.ChevronRight,
  ChevronLeft = icons_1.Icons.ChevronLeft,
  TickCircle = icons_1.Icons.TickCircle,
  ChevronRightCircle = icons_1.Icons.ChevronRightCircle;
exports.IconButtonDefaultProps = {
  inverted: false,
  anchor: 'start',
  forceAnchorTag: false,
  type: 'button',
  color: 'link',
  hoverColor: 'linkHover',
  disabled: false,
  iconSize: 20,
  iconRatio: 1,
  useSpan: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    cursor: pointer;\n    flex-wrap: nowrap;\n    display: flex;\n    justify-content: center;\n    font-family: ", ";\n    align-items: center;\n    font-weight: 500;\n    font-size: ", ";\n    text-transform: capitalize;\n    text-decoration: none;\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    transition: opacity 0.2s;\n\n    ", "\n \n    ", "\n\n    &:hover, &:focus {\n      outline: none;\n      text-decoration: none;\n      ", "\n\n      ", "\n    }\n\n    &:focus {\n    }\n\n    &:active {\n      text-decoration: none;\n    }\n\n    ", "\n\n  "], ["\n    cursor: pointer;\n    flex-wrap: nowrap;\n    display: flex;\n    justify-content: center;\n    font-family: ", ";\n    align-items: center;\n    font-weight: 500;\n    font-size: ", ";\n    text-transform: capitalize;\n    text-decoration: none;\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    transition: opacity 0.2s;\n\n    ", "\n \n    ", "\n\n    &:hover, &:focus {\n      outline: none;\n      text-decoration: none;\n      ", "\n\n      ", "\n    }\n\n    &:focus {\n    }\n\n    &:active {\n      text-decoration: none;\n    }\n\n    ", "\n\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(13), function (_a) {
    var _color = _a._color;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n    "], ["\n      color: ", ";\n      ", ";\n    "])), theme_1.theme.COLOR(_color), theme_1.theme.FILL(_color));
  }, function (_a) {
    var inverted = _a.inverted;
    return inverted && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n    "], ["\n      color: ", ";\n      ", ";\n    "])), theme_1.theme.COLOR('light'), theme_1.theme.FILL('light'));
  }, function (_a) {
    var _hovercolor = _a._hovercolor;
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        color: ", ";\n        ", ";\n      "], ["\n        color: ", ";\n        ", ";\n      "])), theme_1.theme.COLOR(_hovercolor), theme_1.theme.FILL(_hovercolor));
  }, function (_a) {
    var inverted = _a.inverted;
    return inverted && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        color: ", ";\n        ", ";\n      "], ["\n        color: ", ";\n        ", ";\n      "])), theme_1.theme.COLOR('yellow'), theme_1.theme.FILL('yellow'));
  }, function (_a) {
    var disabled = _a.disabled,
      _color = _a._color;
    return disabled && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      opacity: 0.2;\n      cursor: default;\n\n      &:hover, &:focus {\n        color: ", ";\n        ", ";\n      }\n    "], ["\n      opacity: 0.2;\n      cursor: default;\n\n      &:hover, &:focus {\n        color: ", ";\n        ", ";\n      }\n    "])), theme_1.theme.COLOR(_color), theme_1.theme.FILL(_color));
  }),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    flex-shrink: 0;\n    ", "\n  "], ["\n    flex-shrink: 0;\n    ", "\n  "])), function (props) {
    return props.priority === "text" && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.priority === "text" && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      display: inline;\n    "], ["\n      display: inline;\n    "])));
  })
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: inline-block;\n    white-space: nowrap;\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: inline-block;\n    white-space: nowrap;\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var anchor = _a.anchor,
      priority = _a.priority;
    return anchor === 'end' && priority !== "text" && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme_1.theme.UNIT(2));
  }, function (_a) {
    var anchor = _a.anchor,
      gap = _a.gap,
      priority = _a.priority;
    return anchor === 'start' && priority !== "text" && (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), gap || theme_1.theme.UNIT(2));
  }, function (props) {
    return !props.hasIcon && (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      margin-left: 0;\n      margin-right: 0;\n    "], ["\n      margin-left: 0;\n      margin-right: 0;\n    "])));
  }, function (props) {
    return props.priority === "icon" && (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n  "])), function (props) {
    return props.priority === "icon" && (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      display: inline;\n    "], ["\n      display: inline;\n    "])));
  }, function (_a) {
    var anchor = _a.anchor;
    return anchor === 'end' && (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme_1.theme.UNIT(2));
  }, function (_a) {
    var anchor = _a.anchor,
      gap = _a.gap;
    return anchor === 'start' && (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), gap || theme_1.theme.UNIT(2));
  }, function (props) {
    return !props.hasIcon && (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      margin-left: 0;\n      margin-right: 0;\n    "], ["\n      margin-left: 0;\n      margin-right: 0;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Button: styled_components_1.default.button(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Span: styled_components_1.default.span(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: (0, styled_components_1.default)(router_1.Link)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  A: styled_components_1.default.a(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled_components_1.default.span.attrs(cls.attr('label'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var IconButton = function (props) {
  var className = props.className,
    onClick = props.onClick,
    iconSize = props.iconSize,
    forceAnchorTag = props.forceAnchorTag,
    iconRatio = props.iconRatio,
    icon = props.icon,
    gap = props.gap,
    children = props.children,
    inverted = props.inverted,
    useSpan = props.useSpan,
    to = props.to,
    anchor = props.anchor,
    disabled = props.disabled,
    type = props.type,
    hoverColor = props.hoverColor,
    title = props.title,
    priority = props.priority,
    isActive = props.isActive;
  var handleClick = function (event) {
    event.preventDefault();
    event.stopPropagation();
    onClick();
  };
  var isAnchorTag = forceAnchorTag || Boolean(to && to.match(/mailto:/i));
  var Tag = to ? isAnchorTag ? My.A : My.Link : useSpan ? My.Span : My.Button;
  var attr = {
    title: title
  };
  if (to) {
    if (isAnchorTag) {
      attr.href = to;
    } else {
      attr.to = to;
    }
  } else {
    attr.inverted = inverted;
  }
  if (onClick) {
    attr.onClick = handleClick;
  }
  if (!useSpan && !to) {
    attr.type = type;
  }
  var color = isActive && !inverted ? 'text' : props.color;
  var iconElement = React.createElement(My.Icon, {
    priority: priority,
    ratio: iconRatio,
    size: iconSize
  }, icon);
  return /* @ts-ignore */React.createElement(Tag, __assign({
    disabled: disabled,
    _color: color,
    _hovercolor: hoverColor
  }, attr, {
    className: className
  }), icon && anchor === 'start' && iconElement, children && React.createElement(My.Label, {
    isActive: isActive,
    priority: priority,
    hasIcon: !!icon,
    gap: gap,
    anchor: anchor
  }, children), icon && anchor === 'end' && iconElement);
};
exports.IconButton = IconButton;
var UpdateIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(PencilCircle, null)
  }));
};
exports.UpdateIconButton = UpdateIconButton;
var DeleteIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props));
};
exports.DeleteIconButton = DeleteIconButton;
var CreateIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(PlusCircle, null)
  }));
};
exports.CreateIconButton = CreateIconButton;
var ExportIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(icons_1.Icons.ArrowDownCircle, null)
  }));
};
exports.ExportIconButton = ExportIconButton;
var DownloadIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(icons_1.Icons.ArrowDownCircle, null)
  }));
};
exports.DownloadIconButton = DownloadIconButton;
var ContinueIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(ChevronRightCircle, null)
  }));
};
exports.ContinueIconButton = ContinueIconButton;
var CloseIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(CrossCircle, null)
  }));
};
exports.CloseIconButton = CloseIconButton;
var LinkIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(CrossCircle, null)
  }));
};
exports.LinkIconButton = LinkIconButton;
var NextIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    anchor: "end",
    iconSize: 14,
    icon: React.createElement(ChevronRight, null)
  }));
};
exports.NextIconButton = NextIconButton;
var PreviousIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    iconSize: 14,
    icon: React.createElement(ChevronLeft, null)
  }));
};
exports.PreviousIconButton = PreviousIconButton;
var SubmitIconButton = function (props) {
  return React.createElement(exports.IconButton, __assign({}, props, {
    icon: React.createElement(TickCircle, null)
  }));
};
exports.SubmitIconButton = SubmitIconButton;
exports.IconButton.defaultProps = exports.IconButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27;